import React from 'react';
import TransitionLink, { TransitionPortal } from "gatsby-plugin-transition-link";
import gsap from 'gsap'

const ROOT_CONTENT_REF = "#layout-container";
const COVER_REF = "tl-cover-el"

const PageTransition = ({ children, length = 2, innerRef = null, ...rest }) => {

  const animateExit = ({ props: { length: seconds }, node }) => {

    const wait = seconds / 6;
    const half = (seconds - wait) / 1.5;

    gsap.to(ROOT_CONTENT_REF, {
      y: '40%',
      opacity: 0,
      ease: "power3.inOut",
      duration: half,
    })

    gsap
      .timeline()
      .to(`.${COVER_REF}`, {
        y: '0',
        ease: "power3.inOut",
        duration: half
      })
      .to(ROOT_CONTENT_REF, {
        y: '0%',
        ease: "power3.inOut",
        duration: half * 0.25,
      })
      .to(`.${COVER_REF}`, {
        y: '-200%',
        ease: "power3.inOut",
        duration: half
      })
      .to(ROOT_CONTENT_REF, {
        opacity: 1,
        ease: "power3.inOut",
        duration: half,
      })

    return;
  };

  return (
    <>
      <TransitionLink
        exit={{
          length: length,
          trigger: ({ exit, node }) => animateExit({ props: exit, node }),
        }}
        entry={{ delay: length / 1.5 }}
        ref={i => innerRef ? innerRef(i) : null}
        {...rest}

      >
        {children}
      </TransitionLink>
      <TransitionPortal>
        <div
          className={COVER_REF}
          style={{
            position: "fixed",
            background: "#0700FF",
            pointerEvents: 'none',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            width: "100vw",
            height: "100vh",
            transform: "translateY(200%)"
          }}
        />
      </TransitionPortal>
    </>
  );
};

export default PageTransition;
